"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Step_1 = __importDefault(require("@material-ui/core/Step"));
const StepConnector_1 = __importDefault(require("@material-ui/core/StepConnector"));
const StepLabel_1 = __importDefault(require("@material-ui/core/StepLabel"));
const Stepper_1 = __importDefault(require("@material-ui/core/Stepper"));
const styles_1 = require("@material-ui/core/styles");
const Done_1 = __importDefault(require("@material-ui/icons/Done"));
const query_1 = require("@reduxjs/toolkit/query");
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_cookie_1 = require("react-cookie");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const ab_tests_api_1 = require("ab-tests-api");
const components_1 = require("components");
const config_1 = require("config");
const consumer_applications_v1_api_1 = require("consumer-applications-v1-api");
const context_1 = require("context");
const inline_colors_1 = require("inline-colors");
const utils_1 = require("utils");
const actions_1 = require("../../applicants/actions");
const actions_2 = require("../actions");
const reducer_1 = require("../reducer");
const utils_2 = require("../utils");
const CreditApplicationWizard = __importStar(require("../wizard_views"));
function Wizard({}) {
    const FormConnector = (0, styles_1.withStyles)({
        alternativeLabel: {
            top: 10,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
        active: {
            '& $line': {
                borderColor: inline_colors_1.INLINE_COLORS.purpleBase,
            },
        },
        completed: {
            '& $line': {
                borderColor: inline_colors_1.INLINE_COLORS.purpleBase,
            },
        },
        line: {
            borderColor: inline_colors_1.INLINE_COLORS.greyLight,
            borderTopWidth: 3,
            borderRadius: 1,
        },
    })(StepConnector_1.default);
    const init = (initialStep) => {
        return { step: initialStep };
    };
    const reducer = (state, action) => {
        switch (action.type) {
            case 'next':
                if (state.step < config_1.WIZARD_STEP.APPROVAL) {
                    return { step: state.step + 1 };
                }
                else {
                    return { step: config_1.WIZARD_STEP.APPROVAL };
                }
            case 'prev':
                if (state.step > config_1.WIZARD_STEP.COLLECT_PERSONAL_INFO) {
                    return { step: state.step - 1 };
                }
                else {
                    return { step: config_1.WIZARD_STEP.COLLECT_PERSONAL_INFO };
                }
            case 'reset':
                return init(action.payload ? action.payload : 0);
            default:
                throw new Error();
        }
    };
    const getToken = () => {
        const query = (0, utils_1.parseQuery)(location.search);
        const token = query[config_1.QUERY_KEY.TOKEN];
        return token;
    };
    //CUSTOM HOOKS
    const location = (0, react_router_dom_1.useLocation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [cookies, setCookie] = (0, react_cookie_1.useCookies)([
        'proveAb',
        'proveStoreAb',
        'storeLinkCampaign',
    ]);
    const history = (0, react_router_dom_1.useHistory)();
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    //REDUX State
    const applicationEnvironment = (0, react_redux_1.useSelector)(reducer_1.selectors.applicationEnvironment);
    const practice = (0, react_redux_1.useSelector)(reducer_1.selectors.practice);
    const prequalification = (0, react_redux_1.useSelector)(reducer_1.selectors.prequalification);
    //COMPONENT STATE
    const [payload, setPayload] = (0, react_1.useState)(null);
    const [applicationId, setApplicationId] = (0, react_1.useState)(null);
    const [locationId, setLocationId] = (0, react_1.useState)(null);
    const [state, dispatchLocal] = (0, react_1.useReducer)(reducer, 0, init);
    const tokenRef = (0, react_1.useRef)(getToken());
    //API HOOKS
    const [assignProveVariant, { isLoading: isFetchingAbVariant }] = (0, ab_tests_api_1.usePostAbTestsV1ParticipantsAssignVariantTestSlugMutation)();
    const [assignWaterfallVariant, { data: waterfallVariant, isLoading: isFetchingWaterfallVariant },] = (0, ab_tests_api_1.usePostAbTestsV1ParticipantsAssignVariantTestSlugMutation)({
        fixedCacheKey: practice
            ? `waterfall-ab-${practice.adsStoreNumber}`
            : 'waterfall-ab-no-store',
    });
    const { data: creditApplicationByTokenValidate, isLoading: isFetchingOTAToken, error: errorFetchingCreditApp, } = (0, consumer_applications_v1_api_1.useGetConsumerApplicationsV1CreditApplicationsTokenTokenValidateQuery)(tokenRef.current
        ? {
            token: tokenRef.current,
        }
        : query_1.skipToken);
    const { data: creditPreApplication } = (0, consumer_applications_v1_api_1.useGetConsumerApplicationsV1PrequalificationsNewQuery)(locationId !== null
        ? {
            locationId,
        }
        : query_1.skipToken);
    const { data: storeLinkCampaignMatches, isLoading: isFetchingCampaignValidation, } = (0, consumer_applications_v1_api_1.useGetConsumerApplicationsV1LinkOtlTokenValidateQuery)(cookies.storeLinkCampaign &&
        ((practice !== null && practice !== undefined) ||
            cookies.storeLinkCampaign.storeId === 'all') &&
        tokenRef.current === undefined
        ? {
            token: cookies.storeLinkCampaign.otl,
            storeLinkCampaign: cookies.storeLinkCampaign.campaignId,
            storeId: practice && practice.adsStoreNumber
                ? practice.adsStoreNumber.toString()
                : 'all',
        }
        : query_1.skipToken, {
        // Return previous data when an error occurs
        selectFromResult: (result) => ({
            ...result,
            data: result.isSuccess,
        }),
    });
    //MISC JS
    const prequalificationUrl = applicationEnvironment?.prequalificationUrl;
    const steps = ['PERSONAL INFO', 'PRE-QUALIFICATION', 'APPROVAL'];
    const mobile_steps = [
        'TELL US ABOUT YOURSELF',
        'PRE-QUALIFICATION',
        'APPROVAL',
    ];
    const moveToNextStep = (data) => {
        dispatchLocal({ type: 'next' });
        (0, utils_1.scrollToTop)();
        if (data) {
            setPayload(data);
        }
    };
    const completePrequalification = (0, react_1.useCallback)(() => {
        moveToNextStep();
    }, []);
    const getScreen = (0, react_1.useMemo)(() => {
        analytics?.track('WizardStep', {
            step: state.step,
        });
        switch (state.step) {
            case config_1.WIZARD_STEP.COLLECT_PERSONAL_INFO:
                return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: waterfallVariant?.variant.name === 'treatment' ? ((0, jsx_runtime_1.jsx)(CreditApplicationWizard.PersonalInfoV2, { moveToNextStep: moveToNextStep, allowChangePractice: (0, lodash_1.isNil)(tokenRef.current), showFindApplication: (0, lodash_1.isNil)(tokenRef.current) })) : ((0, jsx_runtime_1.jsx)(CreditApplicationWizard.PersonalInfo, { onContinue: moveToNextStep, allowChangePractice: (0, lodash_1.isNil)(tokenRef.current), showFindApplication: (0, lodash_1.isNil)(tokenRef.current) })) }));
            case config_1.WIZARD_STEP.PERFORM_PREQUALIFICATION:
                return ((0, jsx_runtime_1.jsx)(CreditApplicationWizard.PreQualification, { payload: payload, onStepComplete: completePrequalification, applicationEnvironment: applicationEnvironment }));
            case config_1.WIZARD_STEP.APPROVAL:
                return (0, jsx_runtime_1.jsx)(CreditApplicationWizard.Approval, {});
            default:
                return (0, jsx_runtime_1.jsx)("p", { children: "Page Not Found" });
        }
    }, [
        state.step,
        waterfallVariant,
        payload,
        applicationEnvironment,
        completePrequalification,
    ]);
    //EFFECTS
    (0, react_1.useEffect)(() => {
        if (!waterfallVariant && !isFetchingWaterfallVariant) {
            assignWaterfallVariant(practice
                ? {
                    testSlug: 'consumer_waterfall_2_0_yes_store_test',
                    body: {
                        locationId: practice?.locationId,
                    },
                }
                : {
                    testSlug: 'consumer_waterfall_2_0_no_store_test',
                    body: {},
                });
        }
        const fromProve = sessionStorage.getItem('fromProve');
        const handleProveAb = async () => {
            const testGroup = await (0, utils_2.assignProveAbVariant)(cookies, assignProveVariant, setCookie, practice
                ? 'consumer_prove_yes_store_test'
                : 'consumer_prove_no_store_test', practice?.locationId);
            if (testGroup === 'treatment' &&
                !fromProve &&
                !location.state?.fromfindMyApp) {
                const provePath = `${config_1.PATH.CREDIT_PORTAL}${config_1.PATH.PROVE?.BASE}${location.search}`;
                history.push(provePath, { practice: practice });
            }
        };
        handleProveAb();
        const selectedLocationId = practice?.locationId;
        setLocationId(selectedLocationId);
        return () => {
            dispatch((0, actions_2.clearApplicationEnvironment)());
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (creditPreApplication) {
            //Currently this is set in both reducers
            dispatch((0, actions_2.setApplicationEnvironment)(creditPreApplication));
            dispatch((0, actions_1.setApplicationEnvironment)(creditPreApplication));
        }
    }, [creditPreApplication]);
    (0, react_1.useEffect)(() => {
        (0, utils_1.scrollToTop)();
        if (location.state?.step === 'PRE-QUALIFICATION') {
            dispatchLocal({ type: 'reset', payload: 1 });
        }
        else if (location.state?.step === 'APPROVAL') {
            dispatchLocal({ type: 'reset', payload: 2 });
        }
    }, [location.pathname, location.state?.step]);
    (0, react_1.useEffect)(() => {
        if (!(0, lodash_1.isNil)(prequalificationUrl) &&
            (0, lodash_1.isNil)(tokenRef.current) &&
            location.state?.fromfindMyApp !== true &&
            !isFetchingOTAToken &&
            !isFetchingAbVariant &&
            !isFetchingCampaignValidation &&
            !storeLinkCampaignMatches) {
            window.location.href = prequalificationUrl;
        }
        else if (!(0, lodash_1.isNil)(tokenRef.current) && creditApplicationByTokenValidate) {
            (0, actions_1.setPersonalInfo)(creditApplicationByTokenValidate.applicant);
            (0, actions_2.setCreditApplication)(creditApplicationByTokenValidate.creditApplication);
            if (creditApplicationByTokenValidate.creditApplication?.applicationId)
                setApplicationId(creditApplicationByTokenValidate.creditApplication.applicationId);
            if ((0, lodash_1.isNil)(creditApplicationByTokenValidate?.creditApplication?.applicationId) &&
                !isFetchingOTAToken &&
                !(0, lodash_1.isNil)(prequalificationUrl) &&
                !storeLinkCampaignMatches &&
                !isFetchingCampaignValidation) {
                window.location.href = prequalificationUrl;
            }
        }
        else if (errorFetchingCreditApp &&
            'message' in errorFetchingCreditApp &&
            errorFetchingCreditApp.message === 'no_credit_application_found') {
            const errMsg = config_1.API_ERROR_MAP.no_credit_application_found_one_time;
            (0, utils_1.reportError)('flashError', {
                componentName: 'Wizard',
                funcName: 'useEffect',
                errType: 'api',
                errURL: window.location.pathname,
                errMsg: errMsg,
            }, errorFetchingCreditApp);
            (0, utils_1.toastError)(errMsg);
            history.push(config_1.CREDIT_PORTAL_URL);
        }
    }, [
        prequalificationUrl,
        creditApplicationByTokenValidate,
        errorFetchingCreditApp,
        storeLinkCampaignMatches,
        isFetchingCampaignValidation,
    ]);
    (0, react_1.useEffect)(() => {
        if (prequalification?.applicationId) {
            setApplicationId(prequalification.applicationId);
        }
    }, [prequalification]);
    (0, react_1.useEffect)(() => {
        if (creditApplicationByTokenValidate) {
            dispatch((0, actions_1.setPersonalInfo)(creditApplicationByTokenValidate.applicant));
            dispatch((0, actions_2.setCreditApplication)(creditApplicationByTokenValidate?.creditApplication));
            dispatch((0, actions_1.setPractice)(creditApplicationByTokenValidate.location));
        }
    }, [creditApplicationByTokenValidate]);
    (0, react_1.useEffect)(() => {
        dispatch((0, actions_2.setLenderName)(''));
    }, []);
    if (isFetchingOTAToken ||
        !applicationEnvironment ||
        isFetchingAbVariant ||
        isFetchingWaterfallVariant ||
        isFetchingCampaignValidation ||
        (!(0, lodash_1.isNil)(prequalificationUrl) &&
            (0, lodash_1.isNil)(applicationId) &&
            !storeLinkCampaignMatches))
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "wizard", children: [(0, jsx_runtime_1.jsxs)("div", { className: "stepper-container", children: [(0, jsx_runtime_1.jsx)("div", { className: "steppper-header", children: mobile_steps[state.step] }), (0, jsx_runtime_1.jsx)(Stepper_1.default, { activeStep: state.step, alternativeLabel: true, connector: (0, jsx_runtime_1.jsx)(FormConnector, {}), children: steps.map((label) => ((0, jsx_runtime_1.jsx)(Step_1.default, { children: (0, jsx_runtime_1.jsx)(StepLabel_1.default, { StepIconComponent: FormStepIcon, children: label }) }, label))) })] }), (0, jsx_runtime_1.jsx)("div", { className: "content", children: getScreen })] }) }));
}
exports.default = Wizard;
function FormStepIcon(props) {
    const useFormStepIconStyles = (0, styles_1.makeStyles)({
        root: {
            color: inline_colors_1.INLINE_COLORS.greyLight,
            display: 'flex',
            width: 'auto',
            height: 22,
            alignItems: 'center',
        },
        active: {
            color: inline_colors_1.INLINE_COLORS.darkgreyBase,
        },
        circle: {
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: inline_colors_1.INLINE_COLORS.darkgreyBase,
            textAlign: 'center',
            padding: '5px',
        },
        activeCircle: {
            zIndex: 1,
            width: 25,
            height: 25,
            borderRadius: '50%',
            backgroundColor: inline_colors_1.INLINE_COLORS.redBase,
        },
        activeSubCircle: {
            zIndex: 2,
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: inline_colors_1.INLINE_COLORS.whiteBase,
            margin: '7.5px',
        },
        completed: {
            color: inline_colors_1.INLINE_COLORS.whiteBase,
            zIndex: 1,
            fontSize: 18,
            padding: '3px',
        },
        completedDiv: {
            backgroundColor: inline_colors_1.INLINE_COLORS.redBase,
            height: 25,
            width: 25,
            borderRadius: '50%',
        },
    });
    const classes = useFormStepIconStyles();
    const { active, completed } = props;
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(classes.root, {
            [classes.active]: active,
        }), children: completed ? ((0, jsx_runtime_1.jsx)("div", { className: classes.completedDiv, children: (0, jsx_runtime_1.jsx)(Done_1.default, { className: classes.completed }) })) : ((0, jsx_runtime_1.jsxs)("div", { className: active ? classes.activeCircle : classes.circle, children: [active ? (0, jsx_runtime_1.jsx)("div", { className: classes.activeSubCircle }) : (0, jsx_runtime_1.jsx)("div", {}), ' '] })) }));
}
